// extracted by mini-css-extract-plugin
export default {"wrapper":"tooltip__wrapper-B1JhP","popup":"tooltip__popup-UzRQl","title":"tooltip__title-yFJyK"};